import { Injectable } from '@angular/core';
import { appConfig } from 'src/app/config/app.config';
import { Designation } from 'src/app/models/Designation';

import { AuthService } from '../auth.service';
import { BackEndService } from '../backEnd.service';
import { ToastService } from 'src/app/util/toast.service';

@Injectable({
  providedIn: 'root',
})
export class DesignationService {
  locationTypeList: string[] = ["country", "state", "district", "town", "area"];
  designationNameList: string[] = ["President", "Vice President", "Treasurer", "Secretary", "Area Manager", "Assistant Manager", "Director", "Chief Financial Officer", "Legal Advisor", "Senior Advisor", "Honorary Chairperson"];
  designation: Designation = new Designation;
  // designationList: Designation[] = [];

  constructor(private backEnd: BackEndService, private auth: AuthService, private toast: ToastService) {
    this.designation = new Designation();
  }

  getList(query) {
    return new Promise((resolve) => {
      this.backEnd.searchObject(appConfig.STORAGE_TABLE.DESIGNATION, query).then((designationList: Designation[]) => {
        for (let designation of designationList) {
          if (designation.emp_json && ((typeof designation.emp_json === 'string'))) {
            designation.emp_json = JSON.parse(designation.emp_json);
          }
        }
        resolve(designationList);
      })
    })
  }
  getSingleDesignation(id, variable?: string) {
    variable = variable ?? "id";
    return new Promise((resolve) => {
      this.backEnd.getSingle(appConfig.STORAGE_TABLE.DESIGNATION, [[variable, id]]).then((designation: Designation) => {
        if (designation.emp_json && ((typeof designation.emp_json === 'string'))) {
          designation.emp_json = JSON.parse(designation.emp_json);
        }
        this.designation = designation;
        resolve(true);
      })
    })
  }


  saveObject(emp, parentId) {
    return new Promise((resolve) => {
      this.designation.emp_json = {
        url: emp.user.url,
        name: emp.user.name,
        role: emp.access,
      }
      this.designation.emp_id = emp.id;

      this.designation.parent_id = parentId;

      this.designation.created_by = this.auth.loggedInEmployee.user.id;
      this.designation.business_id = this.auth.business.id;
      this.backEnd.saveObject(appConfig.STORAGE_TABLE.DESIGNATION, this.designation).then((response) => {
        if (response) {
          resolve(true);
        } else {
          resolve(false);
        }
      });
    });
  }

  getCount(location, locationValue, groupLocation) {
    // (business_id_value, filter_column, filter_value, group_column)
    return new Promise((resolve) => {

      this.backEnd.rpcFunction('get_status_counts_by_location',
        {
          business_id_value: this.auth.business.id,
          filter_column: location,
          filter_value: locationValue,
          group_column: groupLocation
        }).then((res: any) => {
          if (res?.body?.data && res?.body?.data.length > 0) {
            resolve(res?.body?.data);
          } else {
            resolve([]);
          }
        }).catch((err: any) => {
          console.error('getCount error:', err);
          resolve([]);
        })
    })

  }

  deleteDesignation(id) {
    return new Promise((resolve) => {
      this.backEnd.deleteObject(appConfig.STORAGE_TABLE.DESIGNATION, id).then((response) => {
        if (response) {
          this.toast.success('Designation deleted successfully');
          resolve(true);
        } else {
          this.toast.success('Failed to delete designation');
          resolve(false);
        }
      });
    });
  }

}
